import { render, staticRenderFns } from "./WarehouseLocationList.vue?vue&type=template&id=9cb04f74&"
import script from "./WarehouseLocationList.vue?vue&type=script&lang=js&"
export * from "./WarehouseLocationList.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseLocationList.vue?vue&type=style&index=0&id=9cb04f74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports